import { axiosInstance } from '@/rest/axios'

const createPositionsApi = () => {
  return {
    getPositionsByAccountNumber: (accountNumber, params = {}) => {
      const searchParams = new URLSearchParams()
      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return
        if (Array.isArray(value)) {
          value.forEach((v) => searchParams.append(key, v))
        } else {
          searchParams.append(key, value)
        }
      })
      const qs = searchParams.toString()
      return axiosInstance.get(
        qs
          ? `v2/positions/${accountNumber}?${qs}`
          : `v2/positions/${accountNumber}`
      )
    },

    split: (positionId) =>
      axiosInstance.delete(`positions/${positionId}/split`),

    pair: (body) => axiosInstance.post('positions/pair', body),

    pairV2: (body) => axiosInstance.post('v2/positions/pair', body),

    updatePricePaid: (positionId, pricePaid) =>
      axiosInstance.patch(`positions/${positionId}/price-paid`, {
        price_paid: pricePaid,
      }),

    getExpiringPositions: () => axiosInstance.get('positions/expiring'),
  }
}

const positionApi = createPositionsApi()

export { positionApi }
